//HEADER

export const MAYZ_LOGO = '/img/mayz/logo.png';

//ICONS
export const CHART = '/img/icons/graph-up.svg#icon';
export const PLUS = '/img/icons/plus.svg#icon';
export const DASH = '/img/icons/dash.svg#icon';

//MAYZ

export const MAYZ_WINK = '/img/mayz/mayz-wink.png';
export const MAYZ_SMILE = '/img/mayz/mayz-smile.png';
export const MAYZ_CONSTRUCTION = '/img/mayz/mayz-construction.png';

//TOKENS

// More tokens images defined in smart db constants images
export const TOKEN_ICON_MAYZ = '/img/tokens/mayz.png';
export const TOKEN_ICON_FT = '/img/tokens/ft.png';

export const TOKEN_COLOR_MAYZ = '#FFC107';
export const TOKEN_COLOR_FT = '#a75ee6';

// SOCIAL
// export const GITHUB = '/img/socials/github1.svg';
export const FACEBOOK = '/img/socials/fb.svg#icon';
export const DISCORD = '/img/socials/ds.svg#icon';
export const TWITTER = '/img/socials/xs.svg#icon';
export const WEBSITE = '/img/socials/website.svg#icon';
export const INSTAGRAM = '/img/socials/ig.svg#icon';
export const MEDIUM = '/img/socials/medium.svg#icon';



